import { Box, Button, Typography, Modal, InputBase } from "@mui/material";
import { useState } from "react";

export const ReturnRequestModal = ({ 
    open, 
    onClose, 
    batchNumber, 
    onSubmit, 
    loading = false 
}) => {
    const [requestReason, setRequestReason] = useState('');
    const [reasonError, setReasonError] = useState('');

    const handleChange = (e) => {
        setRequestReason(e.target.value);
        if (reasonError) setReasonError('');
    };

    const handleSubmit = () => {
        if (!requestReason.trim()) {
            setReasonError('Request reason is required');
            return;
        }
        onSubmit(requestReason.trim());
    };

    const handleClose = () => {
        setRequestReason('');
        setReasonError('');
        onClose();
    };

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="return-request-modal-title"
            aria-describedby="return-request-modal-description"
            sx={{ zIndex: 1000 }}
        >
            <Box sx={{ 
                position: 'absolute', 
                top: '50%', 
                left: '50%', 
                transform: 'translate(-50%, -50%)', 
                width: '100%', 
                maxWidth: "500px", 
                backgroundColor: 'white',
                borderRadius: '4px'
            }}>
                <Box sx={{ height: "46px", padding: "12px 24px", backgroundColor: "#EEEEEE", display: "flex", alignItems: "center" }}>
                    <Typography sx={{ fontSize: "14px", fontWeight: "500", lineHeight: "22px" }}>
                        Request Return - Batch {batchNumber}
                    </Typography>
                </Box>
                <Box sx={{ padding: "24px", display: "flex", gap: "16px", flexDirection: "column" }}>
                    <Typography sx={{ fontSize: "14px", color: "gray", marginBottom: "8px" }}>
                        This will reduce inventory counts to original values before this batch was added.
                    </Typography>
                    <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                        <Typography sx={{ fontSize: "14px", fontWeight: "400", lineHeight: "22px" }}>
                            Request Reason <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                        </Typography>
                        <InputBase
                            value={requestReason}
                            onChange={handleChange}
                            multiline
                            rows={4}
                            placeholder="Enter reason for return request"
                            sx={{ 
                                backgroundColor: "white", 
                                width: "100%", 
                                borderRadius: "2px", 
                                border: "1px solid", 
                                borderColor: reasonError ? "red" : "secondary.border", 
                                padding: "8px 12px", 
                                fontSize: "14px", 
                                fontWeight: "400", 
                                lineHeight: "22px", 
                                color: "black",
                                minHeight: "80px"
                            }}
                        />
                        {reasonError && (
                            <Typography sx={{ fontSize: "12px", color: "red", fontWeight: "400" }}>
                                {reasonError}
                            </Typography>
                        )}
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "flex-end", gap: "12px", marginTop: "8px" }}>
                        <Button 
                            variant="outlined" 
                            onClick={handleClose}
                            disabled={loading}
                            sx={{ textTransform: "none", height: "32px" }}
                        >
                            Cancel
                        </Button>
                        <Button 
                            variant="contained" 
                            onClick={handleSubmit}
                            disabled={loading}
                            sx={{ textTransform: "none", height: "32px" }}
                        >
                            {loading ? "Submitting..." : "Submit Request"}
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Modal>
    );
};


